import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SharedModule } from 'app/shared/shared.module';
import { DashboardCompetition, DashboardService, DashboardStats } from './dashboard.service';
import { DashboardAd } from './dashboard.service';

@Component({
    selector: 'break-record-dashboard',
    templateUrl: './dashboard.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [SharedModule, RouterLink],
})
export class DashboardComponent implements OnInit {
    private readonly changeDetector = inject(ChangeDetectorRef);
    private readonly dashboardService = inject(DashboardService);

    stats: DashboardStats | null = null;
    competitions: DashboardCompetition[] = [];
    ads: DashboardAd[] = [];
    isLoading = true;
    error = '';

    ngOnInit(): void {
        this.load();
    }

    load(): void {
        this.isLoading = true;
        this.error = '';
        this.dashboardService.load().subscribe({
            next: (data) => {
                this.stats = data.stats;
                this.competitions = data.competitions.data || [];
                this.ads = data.ads || [];
                this.isLoading = false;
                this.changeDetector.markForCheck();
            },
            error: () => {
                this.error = 'Impossible de charger les données du tableau de bord.';
                this.isLoading = false;
                this.changeDetector.markForCheck();
            },
        });
    }

    stateLabel(state: string): string {
        return { ongoing: 'En direct', upcoming: 'À venir', finished: 'Terminée' }[state] || state;
    }

    stateClass(state: string): string {
        return { ongoing: 'bg-green-100 text-green-800', upcoming: 'bg-amber-100 text-amber-800', finished: 'bg-gray-100 text-gray-700' }[state] || 'bg-gray-100 text-gray-700';
    }
}
